import { watch } from "vue";

class WatchVariable {
  constructor() {
    this.watchers = new Map();
  }

  add(target, key, callback, autoClose = null) {
    const watcherID = `${key}-${Date.now()}`;
    if (this.watchers.has(watcherID)) {
      console.warn(`Un watcher existe déjà pour ${key}`);
      return;
    }

    const stopWatcher = watch(
      () => {
        try {
          return key.split(".").reduce((obj, k) => obj?.[k], target);
        } catch (error) {
          console.error(`Erreur dans WatchVariable: Impossible d'accéder à ${key}`, error);
          return undefined;
        }
      },
      (newValue, oldValue) => {
        callback(newValue, oldValue, watcherID);
      },
      { deep: true }
    );

    this.watchers.set(watcherID, stopWatcher);

    if (autoClose !== null) {
      setTimeout(() => {
        if (this.watchers.has(watcherID)) {
          this.remove(watcherID);
          autoClose();
        }
      }, ENV.KILL_RESPONSE_API);
    }
  }

  remove(watcherID) {
    if (this.watchers.has(watcherID)) {
      this.watchers.get(watcherID)(); // Stop le watcher
      this.watchers.delete(watcherID);
    } else {
      console.warn(`Aucun watcher trouvé pour ${watcherID}`);
    }
  }
}

export default WatchVariable;
